<template>
  <v-content>
    <v-row>
      <v-col>

      </v-col>
      <v-col>
        <LoginForm
          :login="login"
          v-on:usernameChanged="usernameChanged($event)"
          v-on:passwordChanged="passwordChanged($event)"
        >
        </LoginForm>
      </v-col>
      <v-col>

      </v-col>
    </v-row>
  </v-content>
</template>

<script>
import LoginForm from '../components/LoginForm.vue';

export default {
  name: 'Login',
  components: {
    LoginForm,
  },

  data() {
    return {
      username: '',
      password: '',
    };
  },

  methods: {
    login() {
      const { $router } = this;

      const options = {
        method: 'POST',
        url: '/auth/token/v1',
        data: `grant_type=password&username=${this.username}&password=${this.password}&client_id=38919759492775BFA7443B270183E6077A2179ECFE421BE5F5E56981447D2DD3`,
        headers: {
          'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
        },
      };

      this.axios(options)
        .then((res) => {
          localStorage.setItem('user-token', JSON.stringify(res.data));
          this.$store.commit('setAuthToken', res.data);

          this.$router.push('/');
        })
        .catch((err) => {
          this.$store.commit('SET_AUTH_STATUS', 'unauthorized');
        });
    },
    usernameChanged(value) {
      this.username = value;
    },
    passwordChanged(value) {
      this.password = value;
    },
  },
};
</script>
